import { render } from "./LauncherBlock.vue?vue&type=template&id=5e1819a0"
import script from "./LauncherBlock.vue?vue&type=script&lang=js"
export * from "./LauncherBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/xpixel/htdocs/xpixel.ru/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__